import axios from "axios";
import React, { useState, useEffect } from "react";
import QuizSettingsWidgetTeacher from "./QuizSettingsWidgetTeacher";
import TeepeeIcon from "../../images/avatar4.png";
import { useLocation, useNavigate } from "react-router-dom";
import amplitude from "amplitude-js";
import Transition from "./Transition";

export const SelectSubject = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const id = params.get("id");

  const location = useLocation();
  const navigate = useNavigate();

  const [subjectsList, setSubjectsList] = useState([]);
  const [activeButtons, setActiveButtons] = useState([]);
  const [loadTime, setLoadTime] = useState(false);

  useEffect(() => {
    if (id) {
      const localstate = localStorage.getItem("experience");
      const subjectArray = subjectsList.filter((subjectObj) => subjectObj.subject_id === parseInt(id));
      const subject = subjectArray[0];

      setLoadTime(true);
      const timeoutId = setTimeout(() => {
        navigate(`/quiz?id=${subject.exam_style[0].secret_key}`, {
          state: {
            subject_name: subject.subject_name,
            minimock: subject.minimock,
            quiz_setting: 1,
            exam_style: subject.exam_style,
            experience: localstate,
          },
        });
        setLoadTime(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [subjectsList]);

  const handleOnClick = (subject, index) => {
    const localstate = localStorage.getItem("experience");
    const subj = subject.subject_name.replace(/\s/g, "");

    amplitude.getInstance().logEvent(localstate === "Teacher" ? "TESelectSubject" + subj : "VESelectSubject" + subj);

    setLoadTime(true);
    const timeoutId = setTimeout(() => {
      navigate(`/quiz?id=${subject.exam_style[0].secret_key}`, {
        state: {
          subject_name: subject.subject_name,
          minimock: subject.minimock,
          quiz_setting: 1,
          exam_style: subject.exam_style,
          experience: localstate,
        },
      });
      setLoadTime(false);
    }, 5000);

    return () => clearTimeout(timeoutId);
  };

  useEffect(() => {
    const experience = localStorage.getItem("experience");
    amplitude.getInstance().logEvent(experience === "Teacher" ? "TEPageView" : "VEMainPageView");
    getSubjectsList();
  }, []);

  const getSubjectsList = () => {
    axios
      .get(`${process.env.REACT_APP_REST_API_BASE_URL}/get_subjects_for_trial`, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        const array = JSON.parse(res.data.data);
        const filteredArray = array.filter((item) => Array.isArray(item.exam_style) && item.exam_style.length > 0);
        filteredArray.push("");
        setSubjectsList(filteredArray);
      });
  };

  const handleClick = () => {
    const url = "https://app.teepee.ai/";
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Navbar */}
      <div className="w-full flex justify-between items-center px-6 py-4 shadow-sm bg-white" style={{ display: loadTime ? "none" : "flex" }}>
        {/* Logo - Image Only */}
        <div className="flex items-center ml-[10%]">
          <img
            src={TeepeeIcon}
            alt="Teepee Logo"
            className="h-10 object-contain"
            style={{ maxWidth: "150px" }} // Adjust max-width as needed
          />
        </div>

        {/* Navigation Links */}
        <div className="flex items-center gap-8">
          <a
            href="https://teepee.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-gray-900 text-[16px] font-poppins no-underline"
          >
            Home
          </a>
          <a
            href="https://app.teepee.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#6750A4] hover:text-purple-700 text-[16px] font-poppins flex items-center gap-1 no-underline"
          >
            Unlimited Exam Practice, Instant Feedback →
          </a>
          <button
            onClick={handleClick}
            className="bg-[#6750A4] text-white px-3 py-1 rounded-full text-[16px] font-poppins font-medium hover:bg-purple-700"
          >
            Try for free
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ display: loadTime ? "none" : "block" }} className="w-full md:mt-[10%] sm:mt-[2%]">
        <div className="flex items-center justify-center flex-col h-full">
          <div className="welcome-teepee-text md:w-[40%] md:text-left sm:w-[90%] sm:text-center mb-[4px] sm:mt-[30%] md:mt-0">
            Experience AI Evaluation
          </div>
          <div className="welcome-teepee-sub-text w-[40%] sm:w-[90%] md:w-[40%] sm:text-center md:text-left mb-[16px]">
            Choose your subject and see how your students will experience instant AI evaluation and marking.
          </div>

          <QuizSettingsWidgetTeacher subjectsList={subjectsList} handleOnClick={handleOnClick} activeButton={activeButtons} />
        </div>
      </div>

      {/* Transition loading state */}
      <div className="w-full md:mt-[10%] sm:mt-[2%]">
        <div className="flex items-center justify-center flex-col h-full">
          <div
            className="md:relative flex mt-[2%] justify-between md:w-[40%] sm:w-[90%] sm:flex-col md:flex-row mb-[3%]"
            style={{ display: loadTime ? "block" : "none" }}
          >
            <Transition />
          </div>
        </div>
      </div>
    </>
  );
};

// <div style={{ display: loadTime ? "none" : "block" }} className="jess_icon left-[35px] md:left-[10%] sm:left-[25%]">
//   <img src={TeepeeIcon} alt="" />
// </div>
